import React from 'react';
import { useTranslation } from 'react-i18next';
import './SocialMedia.css';

function SocialMedia() {
  const { t } = useTranslation();

  const socialLinks = [
    {
      name: 'Instagram',
      icon: '📸',
      url: 'https://www.instagram.com/radiotunco?igsh=aXBudWNlZDNpY2No&utm_source=qr',
      handle: '@radiotunco',
      color: 'var(--color-rose-gold)',
      description: 'Follow our visual journey'
    },
    {
      name: 'TikTok',
      icon: '🎵',
      url: 'https://www.tiktok.com/@radiotunco',
      handle: '@radiotunco',
      color: 'var(--color-turquoise)',
      description: 'Short music clips and behind the scenes'
    }
  ];

  return (
    <section className="social-media" id="social">
      <div className="container">
        <div className="section-header animate-fade-in-up">
          <h2>{t('social.title')}</h2>
          <p className="section-description">
            {t('social.followUs')}
          </p>
        </div>

        <div className="social-grid">
          {socialLinks.map((social, index) => (
            <div key={index} className="social-card animate-fade-in-up">
              <div className="social-icon-container">
                <div className="social-icon" style={{'--social-color': social.color}}>
                  {social.icon}
                </div>
                <div className="social-glow" style={{'--social-color': social.color}}></div>
              </div>

              <div className="social-content">
                <h3>{social.name}</h3>
                <p className="social-handle">{social.handle}</p>
                <p className="social-description">{social.description}</p>

                <a
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  style={{'--social-color': social.color}}
                >
                  {social.name === 'Instagram' ? t('social.instagram') : t('social.tiktok')}
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="social-stats animate-fade-in-up">
          <div className="stat-item">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Live Content</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">∞</div>
            <div className="stat-label">Music Genres</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">🌍</div>
            <div className="stat-label">Global Reach</div>
          </div>
        </div>

        <div className="community-message animate-fade-in-up">
          <div className="message-container">
            <p>"Join our global community of music lovers, dreamers, and conscious creators"</p>
            <div className="message-accent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialMedia;